var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7253 14.3371L15.6628 0.27457C15.2972 -0.0915235 14.7028 -0.0915235 14.3372 0.27457L0.274657 14.3371C0.0065316 14.6052 -0.0736246 15.0083 0.0712191 15.3585C0.216532 15.7091 0.55825 15.9374 0.937469 15.9374H3.74997V29.0624C3.74997 29.5799 4.16997 29.9999 4.68747 29.9999H11.25C11.7675 29.9999 12.1875 29.5799 12.1875 29.0624V25.3124C12.1875 24.7949 12.6075 24.3749 13.125 24.3749C13.6425 24.3749 16.3575 24.3749 16.875 24.3749C17.3925 24.3749 17.8125 24.7949 17.8125 25.3124V29.0624C17.8125 29.5799 18.2325 29.9999 18.75 29.9999H25.3125C25.83 29.9999 26.25 29.5799 26.25 29.0624V15.9374H29.0625C29.4417 15.9374 29.7834 15.7091 29.9287 15.3585C30.0736 15.0083 29.9934 14.6052 29.7253 14.3371Z",
    fill: "url(#paint0_linear_3_36)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_36",
    x1: 14.8762,
    y1: -0.526171,
    x2: 14.8762,
    y2: 30.0683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6E04"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.a4776dcb7033081cdaf824ed818c5b81.svg";
export { ForwardRef as ReactComponent };